import {
  RemoteParticipantList,
  StatsDownloadService,
  StatsDto,
  StatsEvent,
  StatsRecorder,
  StatsReportMap,
  StatsStoreService
} from "@domain";
import { StatsApiService } from "./StatsApiService";

export class StatsRecordingService {
  private storage: StatsStoreService;
  private storedReport: StatsDto | null = null;
  private statsService: StatsApiService = new StatsApiService();
  constructor(private stats: StatsRecorder) {
    this.storage = new StatsStoreService(this.stats);
    this.stats
      .getService()
      .addEventListener(StatsEvent.TICK, this.storeStats.bind(this));
  }

  public get report(): StatsDto | null {
    return this.storedReport;
  }

  public storeStats(e: unknown): void {
    const event = e as CustomEvent<StatsReportMap>;
    const stats = event.detail;
    this.storage.storeStats(stats);
  }

  public async saveStats(): Promise<void> {
    const storedReport = this.storage.getStats();
    await this.statsService.save(storedReport, this.stats.toString());
  }

  public removeStats(): void {
    this.storage.removeStats();
  }

  public exportToCsv(): void {
    const storedReport = this.storage.getStats();
    StatsDownloadService.exportToCsv(storedReport, this.stats.toString());
  }

  public exportToJson(): void {
    const storedReport = this.storage.getStats();
    StatsDownloadService.exportToJson(storedReport, this.stats.toString());
  }

  public start(participants: RemoteParticipantList): void {
    this.stats.start(participants);
  }

  public stop(): void {
    this.stats.stop();
    this.storedReport = this.storage.getStats();
  }
}
